import React, { useEffect, useState } from 'react';
import { getTelegramPrefs, updateTelegramPrefs, sendTelegramTest } from '../../lib/api';
import { Card, CardContent } from '../ui/card';
import { Switch } from '../ui/switch';
import { Label } from '../ui/label';
import { Button } from '../ui/button';
import { Send, Loader2, BellRing } from 'lucide-react';
import { toast } from 'sonner';

export const TelegramPrefsCard = () => {
  const [prefs, setPrefs] = useState(null);
  const [labels, setLabels] = useState({});
  const [saving, setSaving] = useState(null);
  const [testing, setTesting] = useState(false);

  useEffect(() => {
    getTelegramPrefs()
      .then((res) => { setPrefs(res.data.prefs); setLabels(res.data.labels); })
      .catch(() => toast.error('Error al cargar notificaciones de Telegram'));
  }, []);

  const toggle = async (key, value) => {
    setSaving(key);
    try {
      const res = await updateTelegramPrefs({ [key]: value });
      setPrefs(res.data.prefs);
      toast.success(`${labels[key]}: ${value ? 'activadas' : 'desactivadas'}`);
    } catch {
      toast.error('No se pudo guardar');
    } finally {
      setSaving(null);
    }
  };

  const test = async () => {
    setTesting(true);
    try {
      await sendTelegramTest();
      toast.success('Mensaje de prueba enviado a Telegram');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'No se pudo enviar la prueba');
    } finally {
      setTesting(false);
    }
  };

  if (!prefs) return null;

  return (
    <Card className="border-border/40 bg-card" data-testid="telegram-prefs-card">
      <CardContent className="p-5 space-y-4">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
          <div className="flex items-center gap-4">
            <div className="p-3 rounded-lg bg-primary/15">
              <BellRing className="w-6 h-6 text-primary" />
            </div>
            <div>
              <p className="font-bold text-base">Notificaciones Telegram</p>
              <p className="text-sm text-muted-foreground mt-0.5">Elige qué avisos llegan a tu Telegram.</p>
            </div>
          </div>
          <Button variant="outline" onClick={test} disabled={testing} data-testid="telegram-test-btn">
            {testing ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Send className="w-4 h-4 mr-2" />}
            Enviar prueba
          </Button>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {Object.keys(labels).map((key) => (
            <div key={key} className="flex items-center justify-between rounded-lg border border-border/40 bg-secondary/30 px-4 py-3">
              <Label htmlFor={`tg-${key}`} className="text-sm">{labels[key]}</Label>
              <Switch
                id={`tg-${key}`}
                checked={prefs[key]}
                disabled={saving === key}
                onCheckedChange={(v) => toggle(key, v)}
                data-testid={`telegram-toggle-${key}`}
              />
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
